export default __webpack_public_path__ + "static/media/ic_british_virgin_islands.2c24098e.svg";